import { Modal, OfferViewKEK } from "components";
import { useKEKOffer, useOffer } from "hooks/data/use-offers";

import { LocationGenerics } from "router/location";
import { useSearch } from "react-location";

export default function ViewInsurerOfferKEKContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { offer, loading } = useKEKOffer({
    offer_id: searchParams.id as string,
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Offer Information"
      description="Details of offer are shown below"
    >
      <OfferViewKEK offer={offer} />
    </Modal>
  );
}
